import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { Button, Card, Divider, Form, Modal, Select, Space, Tabs } from "antd";
import Layouts from "../../../components/Layouts";
import { getDirectusClient } from "../../../lib/directus";
import Addfileproducts from "../components/Addfileproducts";
import Addcaja from "../components/Addcaja";
import {
  readItem,
  readItems,
  readUser,
  updateItem,
  updateItems,
} from "@directus/sdk";
import { useSelector } from "react-redux";

const { Option } = Select;

const onChange = (key) => {
  console.log(key);
};

function OrdeEnter(props) {
  let { order_id } = useParams();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [order, setOrder] = useState({});
  const [bodegas, setBodegas] = useState([]);
  const [productselect, setProductselect] = useState([]);
  const [order1, setOrder1] = useState({});
  const user = useSelector((state) => state.userdata);
  const navigate = useNavigate();
  const [createdByUser, setCreatedByUser] = useState(null);
  const [totals, setTotals] = useState({
    subtotal: 0,
    groupTaxTotal: 0,
    iscTotal: 0,
    grandTotal: 0,
  });

  const getOrder = async () => {
    const directus = await getDirectusClient();
    await directus
      .request(
        readItem("ordenes_decompra", order_id, {
          fields: [
            "*.*",
            "productos",
            "productos.id",
            "productos.nombre",
            "productos.preciosinimp",
            "productos.grupo.nombre",
            "productos.estado.nombre",
            "productos.seriales",
            "productos.producto_detalle.*",
            "productos.producto_detalle.grupo.*",
            "productos.producto_detalle.id",
            "productos.cantidad",
          ],
          // filter: {
          //   count: ["productos.id"],
          // },
        })
      )
      .then((res) => {
        console.log(res);

        let ordenn = res;

        setOrder(ordenn);

        /*  ordenn.productos.map(async (producto) => {
          await directus
            .request("seriales")
            readItems({
              fields: "*.*",
              limit: -1,
              filter: { producto_odc: producto.id },
            })
            .then((res) => {
              console.log(res);
              producto.totalproductosagregados = res.data.length;
            });
        });*/
      });
  };

  const getBodegas = async () => {
    const directus = await getDirectusClient();

    await directus
      .request(readItems("bodegas", { fields: "*.*" }))
      .then((res) => {
        console.log(res);
        setBodegas(res.data);
      });
  };

  useEffect(() => {
    console.log(order_id);

    getOrder();
    getBodegas();
  }, []);

  const onFinish = async (values) => {
    const directus = await getDirectusClient();
    await directus.request(
      updateItem("ordenes_decompra", order_id, {
        bodegas: [{ id: values.bodega }],
      })
    );
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const getUserDetails = async (userId) => {
    const directus = await getDirectusClient();
    try {
      const user = await directus.request(
        readUser(userId, {
          fields: ["first_name", "last_name", "email"],
        })
      );
      setCreatedByUser(user);
    } catch (err) {
      console.error("Error fetching user details:", err);
    }
  };

  const showModal = async (producto) => {
    setProductselect(producto);
    if (producto.user_created) {
      await getUserDetails(producto.user_created);
    }
    setIsModalOpen(true);
  };

  const handleOk = async () => {
    await getOrder();
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };
  console.log("products", order.bodegas[0].bodegas_id);

  const items = [
    {
      key: "1",
      label: `Subir archivo csv`,
      children: (
        <Addfileproducts
          modal={isModalOpen}
          producto={productselect}
          getOrder={getOrder}
          order={order_id}
          bodegaId={order.bodegas[0].bodegas_id}
        />
      ),
    },
    /*{
      /*
      key: "2",
      label: `Lector codebar`,
      
      children: (
        <Addcaja
          modal={isModalOpen}
          producto={productselect}
          getOrder={getOrder}
        />
      ),
      
    },*/
    {
      key: "3",
      label: `Por caja`,
      children: (
        <Addcaja
          producto={productselect}
          order={order_id}
         bodegaId={order.bodegas[0].bodegas_id}
          onSuccess={() => {
            getOrder();
          }}
        />
      ),
    },
  ];

  const cerrarOrden = async () => {
    const directus = await getDirectusClient();
    try {
      // First update order status
      await directus.request(
        updateItem("ordenes_decompra", order_id, {
          estado: 3,
          ingresado_por: user.id,
        })
      );

      // Get serials with estado 5 and specific order
      const seriales = await directus.request(
        readItems("seriales", {
          filter: {
            estado: {
              _eq: 5,
            },
            orden_compra_ingreso: {
              _eq: order_id,
            },
          },
        })
      );

      if (seriales && seriales.length > 0) {
        const updatedSerials = await directus.request(
          updateItems(
            "seriales",
            seriales.map((serial) => serial.id),
            {
              estado: 1,
            }
          )
        );

        Modal.success({
          content: `Orden cerrada con éxito. Se activaron ${updatedSerials.length} seriales`,
          onOk: () => navigate("/order_list"),
        });
      }
    } catch (err) {
      console.error("Error:", err);
      Modal.error({
        content: "Error al cerrar la orden",
      });
    }
  };
  console.log("product select", productselect);

  const calculateProductTaxes = async (producto) => {
    if (!producto?.producto_detalle?.id || !producto?.precio_uni_final)
      return null;

    try {
      const directus = await getDirectusClient();
      const groupTaxPercentage = parseFloat(
        producto.producto_detalle.grupo.impuesto || 0
      );
      const precioBase = producto.precio_uni_final * producto.seriales.length;
      const groupTaxAmount = precioBase * (groupTaxPercentage / 100);

      // Check for ISC tax
      const taxes = await directus.request(
        readItems("impuestos", {
          fields: ["nombre", "porcentaje"],
          filter: {
            gropo: { grupos_id: { _eq: producto.producto_detalle.grupo.id } },
            nombre: { _eq: "ISC" },
          },
        })
      );

      let iscAmount = 0;
      if (taxes && taxes[0]?.porcentaje) {
        const iscPercentage = parseFloat(taxes[0].porcentaje);
        iscAmount = precioBase * (iscPercentage / 100);
      }

      return {
        precioBase,
        groupTaxAmount,
        iscAmount,
        total: precioBase + groupTaxAmount + iscAmount,
      };
    } catch (error) {
      console.error("Error calculating taxes:", error);
      return null;
    }
  };

  useEffect(() => {
    const calculateTotals = async () => {
      if (!order.productos) return;

      let subtotal = 0;
      let groupTaxTotal = 0;
      let iscTotal = 0;

      for (const producto of order.productos) {
        const taxes = await calculateProductTaxes(producto);
        if (taxes) {
          subtotal += taxes.precioBase;
          groupTaxTotal += taxes.groupTaxAmount;
          iscTotal += taxes.iscAmount;
        }
      }

      setTotals({
        subtotal,
        groupTaxTotal,
        iscTotal,
        grandTotal: subtotal + groupTaxTotal + iscTotal,
      });
    };

    calculateTotals();
  }, [order.productos]);

  const formatPrice = (price) => {
    return new Intl.NumberFormat("es-CO", {
      style: "currency",
      currency: "COP",
    }).format(price);
  };

  const getProductStats = (producto) => {
    return {
      totalIngresados: producto.seriales.length,
      cantidadPendiente: producto.cantidad - producto.seriales.length,
      precioTotal: producto.seriales.length * producto.precio_uni_final,
    };
  };

  const orderTotals = React.useMemo(() => {
    if (!order.productos)
      return {
        totalProductos: 0,
        totalIngresados: 0,
        totalPendientes: 0,
        precioTotal: 0,
      };

    return order.productos.reduce(
      (acc, producto) => {
        const stats = getProductStats(producto);
        return {
          totalProductos: acc.totalProductos + producto.cantidad,
          totalIngresados: acc.totalIngresados + stats.totalIngresados,
          totalPendientes: acc.totalPendientes + stats.cantidadPendiente,
          precioTotal: acc.precioTotal + stats.precioTotal,
        };
      },
      {
        totalProductos: 0,
        totalIngresados: 0,
        totalPendientes: 0,
        precioTotal: 0,
      }
    );
  }, [order.productos]);

  return (
    <Layouts>
      <Space direction="vertical" size="middle" style={{ display: "flex" }}>
        <Card title="Ingresar Orden">
          <Space
            split={<Divider type="vertical" />}
            size={"large"}
            style={{ display: "flex", justifyContent: "center" }}
          >
            <p>Orden #: {order.id} </p>
            <p>Factura #: {order.numero_factura} </p>
            <p>proveedor : {order.proveedor ? order.proveedor.nombre : null}</p>

            <p>fecha creacion : {order.date_created}</p>
          </Space>
        </Card>
        <div>
          {order.productos
            ? order.productos.map((producto) => {
                const stats = getProductStats(producto);

                return (
                  <Card key={producto.id}>
                    <Space
                      direction="horizontal"
                      split={<Divider type="vertical" />}
                    >
                      {producto ? producto.producto_detalle.nombre : null}
                      <p>Cantidad Pendiente: {stats.cantidadPendiente}</p>
                      <p>Ingresados: {stats.totalIngresados}</p>
                      <Button
                        onClick={() => {
                          showModal(producto);
                        }}
                      >
                        Ingresar
                      </Button>
                    </Space>
                  </Card>
                );
              })
            : null}
          <p>Productos para agregar: {orderTotals.totalProductos}</p>
          <p> Total productos agregados: {orderTotals.totalIngresados}</p>
          <p>Productos faltantes: {orderTotals.totalPendientes}</p>
          <p>Precio total agregado: {formatPrice(orderTotals.precioTotal)}</p>
          <div
            style={{
              marginTop: 16,
              padding: 16,
              background: "#f5f5f5",
              borderRadius: 8,
              width: "fit-content",
              marginLeft: "auto",
            }}
          >
            <p style={{ margin: "0 0 8px" }}>
              Subtotal: {formatPrice(totals.subtotal)}
            </p>
            <p style={{ margin: "0 0 8px" }}>
              Impuesto itbms: {formatPrice(totals.groupTaxTotal)}
            </p>
            <p style={{ margin: "0 0 8px" }}>
              ISC: {formatPrice(totals.iscTotal)}
            </p>
            <p
              style={{
                margin: 0,
                fontWeight: "bold",
                borderTop: "1px solid #d9d9d9",
                paddingTop: 8,
              }}
            >
              Total Final: {formatPrice(totals.grandTotal)}
            </p>
          </div>
          <Button
            type="primary"
            disabled={
              orderTotals.totalProductos === orderTotals.totalIngresados
                ? false
                : true
            }
            onClick={cerrarOrden}
          >
            Cerrar orden de compra
          </Button>
        </div>
        <div>
          <Modal
            width={700}
            footer={[
              <Button key="ok" type="primary" onClick={handleOk}>
                ok
              </Button>,
            ]}
            title="Ingresar producto"
            open={isModalOpen}
            onOk={handleOk}
            onCancel={handleCancel}
          >
            <p>
              {productselect.producto_detalle
                ? productselect.producto_detalle.nombre
                : null}
            </p>
            <p>
              Creado por:{" "}
              {createdByUser
                ? `${createdByUser.first_name} ${createdByUser.last_name}`
                : "Cargando..."}
            </p>
            {productselect.id && (
              <>
                <p>
                  Cantidad Pendiente:{" "}
                  {getProductStats(productselect).cantidadPendiente}
                </p>
                <p>
                  Ingresados: {getProductStats(productselect).totalIngresados}
                </p>
              </>
            )}

            <Tabs defaultActiveKey="1" items={items} onChange={onChange} />
          </Modal>
        </div>
      </Space>
    </Layouts>
  );
}

export default OrdeEnter;
